export default __webpack_public_path__ + "static/media/farm-duty-single.020d8d13.png";